import type { StepConfigFor } from '../getStepConfig.types.ts';

export const DocumentUploadStepConfig = {
  statuses: {
    NOT_STARTED: {
      label: 'Not Uploaded',
      cta: 'Upload Now',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient is tasked with uploading their document'
          : 'Please upload the required document',
    },

    PENDING: {
      label: 'Under Review',
      cta: 'Resubmit',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has uploaded their document. We need to review it and update the status'
          : 'Your document is being reviewed. We will update you shortly',
    },

    COMPLETED: {
      label: 'Approved',
      cta: 'View',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has successfully uploaded their document. We have approved it'
          : 'Your document has been approved',
    },

    ERROR: {
      label: 'Needs Resubmission',
      cta: 'Resubmit Now',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The uploaded file is incorrect, missing or has missing required information. The patient will need to resubmit it'
          : 'There was an issue with your document. Please resubmit it',
    },
  },
} satisfies StepConfigFor<'DOCUMENT_UPLOAD'>;
